const glsl = require("babel-plugin-glsl/macro");

// vertex shader
export const vertexShader = glsl`
  varying vec2 vUv;

  void main() {
    vUv = uv;
    gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
  }
`;

// fragment shader
export const fragmentShader = glsl`
  precision highp float;
  #pragma glslify: noise = require(glsl-noise/simplex/3d.glsl);

  uniform float pattern;
  uniform float blur;
  uniform float scale;
  uniform float size;
  uniform float density;
  uniform float time;

  uniform vec3 bgColor;
  uniform vec3 lineColor1;
  uniform vec3 lineColor2;

  varying vec2 vUv;

  float patternLine(float v) {
    float f = abs(fract(v) - .5);
    float df = fwidth(v) * density;
    return smoothstep(blur, df, f);
  }

  float loopNoise (vec2 v, float t, float scale, float offset) {
    float duration = scale;
    float current = t * scale;
    return ((duration - current) * noise(vec3(v, current + offset)) + current * noise(vec3(v, current - duration + offset))) / duration;
  }

  vec3 gradient() {
    return mix(lineColor2, lineColor1, vUv.x + vUv.y);
  }

  float box(vec2 st, vec2 w){
    // bottom-left
    vec2 bl = step(w, st);
    float pct = bl.x * bl.y;

    // top-right
    vec2 tr = step(w, 1.0 - st);
    pct *= tr.x * tr.y;

    return pct;
  }

  void main () {
    vec2 p = vUv * scale;
    float amp = 0.5;
    float v = 0.0;

    v += loopNoise(p, time, 1.0, pattern) * amp;
    amp *= 0.5;
    p *= 2.0;
    v /= size;

    float t = patternLine(v);
    t *= box(vUv, vec2(0.01));
    vec3 fragColor = mix(gradient(), bgColor, t);

    gl_FragColor = vec4(fragColor, 1.0);
  }
`;
